import React from 'react';
import { withRouter } from 'react-router-dom';
import { getMessage } from '~/assets/utils';

import './css/footer.css';

class Footer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {
        return(
            <footer className='pb-4 pt-2 text-white-50 sticky-bottom footer-content'>
                <div className='footer-container'>
                    <div className='row'>
                        <div className='col-sm-4 col-lg-2 mt-2 footer-link-content ml-auto mr-auto'>
                            <div className='row'>
                                <div className='col-12 mb-3 footer-link-content'>
                                    <p className='footer-title'>{getMessage('policy')}</p>
                                    <a href={process.env.REACT_APP_URL + '/policy-exchanges'}>{getMessage('policy_exchanges')}</a>
                                    <a href={process.env.REACT_APP_URL + '/terms-of-use'}>{getMessage('terms_of_use')}</a>
                                </div>
                                <div className='col-12 footer-link-content mb-2'>
                                    <p className='footer-title'>{getMessage('about')}</p>
                                    <a href={process.env.REACT_APP_URL + '/about-us'}>{getMessage('who_ami')}</a>
                                </div>
                                <div className='col-12 footer-link-content'>
                                    <a className='mb-2' href='javascript:void(0);' style={{textDecoration: 'none'}}><strong>{getMessage('social_links')}</strong></a>
                                    <div className='links d-flex aling-items-center'>
                                        <a className='d-inline-block mr-2' href='https://www.instagram.com/tookas_surf/'>
                                            <img width='23px' src={process.env.PUBLIC_URL + '/images/instagram.png'} className='img-fluid' alt='Tookas'/>
                                        </a>
                                        <a className='d-inline-block mr-2' href='https://www.facebook.com/tookas.surf.street'>
                                            <img width='20px' src={process.env.PUBLIC_URL + '/images/facebook.png'} className='img-fluid' alt='Tookas'/>
                                        </a>
                                        <a className='d-inline-block mr-2' href='https://www.youtube.com/channel/UC3boFMpxlejxKbgthNbY4EQ'>
                                            <img width='25px' src={process.env.PUBLIC_URL + '/images/youtube.png'} className='img-fluid' alt='Tookas'/>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-sm-4 col-lg-2 mt-2 footer-link-content ml-auto mr-auto'>
                            <p className='footer-title'>{getMessage('faq')}</p>
                            <a href={process.env.REACT_APP_CONTACT_URL}>{getMessage('contact_us')}</a>
                        </div>
                        <div className='col-sm-4 col-lg-3 mt-2 ml-auto mr-auto'>
                            <p className='footer-title'>{getMessage('payment_types')}</p>
                            <img alt='Visa' src={require('./images/logo_visa.png')} width='56px' height='36px' className='mb-2' />&nbsp;
                            <img alt='Mastercard' src={require('./images/logo_mastercard.png')} width='56px' height='36px' className='mb-2' />&nbsp;
                            <img alt='Hipercard' src={require('./images/logo_hipercard.png')} width='56px' height='36px' className='mb-2' />&nbsp;
                            <img alt='Elo' src={require('./images/logo_elo.png')} width='56px' height='36px' className='mb-2' />&nbsp;
                            <img alt='Elo Black' src={require('./images/logo_elo-black.png')} width='56px' height='36px' className='mb-2' />&nbsp;
                            <img alt='American' src={require('./images/logo_american.png')} width='56px' height='36px' className='mb-2' />&nbsp;
                        </div>
                        <div className='col-sm-4 col-lg-3 mt-2 ml-auto mr-auto d-none d-lg-block'>
                            <p className='footer-title'>{getMessage('bay_on')}</p>
                            <a href={process.env.REACT_APP_IOS}>
                                <img alt='Apple Store' src={require('./images/img_appstore.png')} width='180px' />
                            </a>
                            <a href={process.env.REACT_APP_ANDROID}>
                                <img alt='Play Store' src={require('./images/img_playstore.png')} width='180px' />
                            </a>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col'>
                            <p>
                                <span dangerouslySetInnerHTML={{__html: process.env.REACT_APP_FOOTER_DESC}} />
                            </p>
                        </div>
                    </div>
                    <hr className='line-divisor' />
                    <div className='row mt-2 footer-content-copyright'>
                        <div className='col-sm-6 col-lg-6 col-xl-6'><p><span>Copyright - {new Date().getFullYear()} AVA Software Solutions - All rights reserved</span></p></div>
                        <div className='col-sm-6 col-lg-6 col-xl-6'><p>Rua Senador Rodrigo Lobo, 1066 – Jardim Iririú. CEP 89224-021 – Joinville/SC. <br/>Fone: (47)3026-2479. <br/>E-mail: <a href='mailto:sac@tookas.com.br'>sac@tookas.com.br</a></p></div>
                    </div>
                </div>
            </footer>
        )
    }
}

export default withRouter(Footer);